import React from 'react';
import ReactDOM from 'react-dom/client';
import { store } from './redux/store.ts';
import App from './App.tsx';
import './index.css';
import { Provider } from 'react-redux';
import { ChatProvider } from './context/ChatProvider.tsx';
import { ChatWidget } from './components/chat/ChatWidget.tsx';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* ChatProvider wraps the whole app so conversation state survives route changes */}
      <ChatProvider>
        <App />
        {/* ChatWidget renders outside the router — launcher + panel persist across navigation */}
        <ChatWidget />
      </ChatProvider>
    </Provider>
  </React.StrictMode>
); 